import { useState } from "react";

const useStateWithLocalstorage = (key, defaultValue) => {
  const initialValue =
    JSON.parse(localStorage.getItem(key) || "null") || defaultValue;

  const [value, setValue] = useState(initialValue);

  const setValueAndLocalstorage = v => {
    setValue(v);
    localStorage.setItem(key, JSON.stringify(v));
  };

  return [value, setValueAndLocalstorage];
};

export default useStateWithLocalstorage;
